
import { defineComponent, ref } from "vue";
import { useAsyncSpinner } from "@/services/Spinner";
import { FormApi } from "@/services/Api";
import { ContactFormModel } from "@/models/Form";
import { useI18n } from "vue-i18n";


export default defineComponent({
    props: {
        policy: {
            type: String,
            required: true
        },
        culture: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const displayResponseMsg = ref<boolean>(false);
        const responseMsg = ref<string>("");
        const { t } = useI18n();
        const contactForm = ref({
            firstName: '',
            lastName: '',
            email: '',
            phoneNumber: '',
            message: '',
        });
        const sendEmail = async (event) => {
            event.preventDefault();
            const contactFormModel: ContactFormModel = {
                firstName: contactForm.value.firstName || '',
                lastName: contactForm.value.lastName || '',
                email: contactForm.value.email || '',
                phoneNumber: contactForm.value.phoneNumber || '',
                message: contactForm.value.message || '',
                culture: props.culture || ''
            }
            await useAsyncSpinner(async () => {
                const response = await FormApi.sendContactForm(contactFormModel);
                if (response) {
                    responseMsg.value = t("ContactForm.Success");
                } else {
                    responseMsg.value = t("ContactForm.Failure");
                }
                emptyFields();
                showResponseMsg();
            });
        }

        const showResponseMsg = () => {
            displayResponseMsg.value = true;
            setTimeout(() => {
                displayResponseMsg.value = false;
            }, 7000);
        }

        const emptyFields = () => {
            contactForm.value.firstName = '';
            contactForm.value.lastName = '';
            contactForm.value.phoneNumber = '';
            contactForm.value.email = '';
            contactForm.value.message = '';
        }

        return {
            sendEmail,
            contactForm,
            displayResponseMsg,
            responseMsg
        };
    },
});
